export const environment = {
  production: false,
  api_prefix: 'https://api.eeviction.com/',
  book_demo_url: 'https://calendly.com/easyeviction/intro',
  version: '19e5d36e1711bea5a285d639d5bac318df966826',
  rum: {
    app_monitor_id: '513689eb-b660-4fdf-8f32-5b846ff89e06',
    identity_pool_id: 'us-east-1:07230ef9-f3db-47c4-a3cf-a5a91b17413b',
    region: 'us-east-1',
    enable_xray: true,
    session_sample_rate: 1,
    signing: false,
    endpoint: 'https://rum.eeviction.com',
  },
};
